// Utils
import { resolveObjectIdsToValues } from './resolveObjectIdsToValues';
/**
 * Decode the given change  change, converting encoded object ids to their corresponding object
 * (defined in the given object maps)
 * `{objectId}.qty`: [undefined, '1'] => 'invoice_lines.0.qty': [1, 2]
 *
 * @param {Change} change
 * @param {ObjectMap} objectMap
 * @param {ObjectMap} objectMapPrevious
 *
 * @return {Change}
 */
export var resolveChangeToValue = function (change, objectMap, objectMapPrevious) {
    var oldValueEncoded = change[0], newValueEncoded = change[1];
    var oldValue = resolveObjectIdsToValues(oldValueEncoded, objectMapPrevious);
    var newValue = resolveObjectIdsToValues(newValueEncoded, objectMap);
    return [oldValue, newValue];
};
//# sourceMappingURL=resolveChangeToValue.js.map